import { useMemo } from 'react';

import styled, { css } from '@mint-lib/styled';

import { Box, TableCellExpander } from '@myn/mui';

import { ROW_HEIGHT } from '../../../../../../constants/campaignBuilder.js';
import { BuilderTableRow } from '../../../../types.js';

export type Props = {
  row: BuilderTableRow;
  isHidden?: boolean;
  scale?: number;
};

function RowExpandButton({ row, isHidden = false, scale = 1 }: Props) {
  const expandOptions = useMemo(() => {
    const options = row.getToggleRowExpandedProps({ title: null });
    return {
      ...options,
      onExpand: options.onClick,
    };
  }, [row]);

  return (
    <Wrapper {...expandOptions} $isHidden={isHidden} $scale={scale}>
      <TableCellExpander expanded={row.isExpanded} display={!isHidden} />
    </Wrapper>
  );
}

const Wrapper = styled(Box)<{ $scale: number; $isHidden: boolean }>`
  ${({ $scale, $isHidden, theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${ROW_HEIGHT * $scale}px;
    width: ${ROW_HEIGHT * $scale}px;
    height: 100%;
    pointer-events: ${$isHidden ? 'none' : 'auto'};
    border-top: 1px solid ${theme.palette.ui.tertiary};

    & .MuiTableCell-root {
      border-top: none;
      min-height: unset;
      height: 100%;
    }
    & .MuiTableCell-root > div {
      min-height: unset;
    }
    & .MuiButtonBase-root {
      transform: scale(${$scale});
    }
  `}
`;

export default RowExpandButton;
